<template>
  <nav class="navbar navbar-expand-sm bg-dark navbar-dark">
    <div class="container-fluid">
      <a class="navbar-brand" href="/index.html">
        {{ titleName }}
      </a>
      <div class="ml-auto d-flex align-items-center"> 
        <button class="btn btn-link" style="color:gray" v-if="store.user.userRole == 'admin'" @click="goUserListPage()">受訓人員列表</button>
        <p class="mb-0 ml-3" style="color:#EFEDE6 !important;">{{ store.user.userName }}</p> 
        <!-- <button class="btn btn-sm btn-DFD6C8 btn-r20 ml-3"  v-if="store.user.userName" @click="cleanCatch()">登出</button> -->
      </div>
    </div>
    <!-- <button class="btn btn-link" style="color:gray" @click="cleanCatch()">清除暫存</button> -->
  </nav>
  <div id="app" style="background-color: #EFEDE6 !important;">
    <router-view></router-view>
  </div>
</template>


<script>
import { useStore } from './store/main';

export default {
  setup() {
		const store = useStore();

		return {
			store,
		};
	},
  name: 'App',
  data() {
    return {
      systemName: window.VUE_APP_System, //recommend //behavior
      isDev: window.VUE_APP_Dev,
      titleName: '運動項目推薦後台管理',
      linecode: '',
      userRole: '',
    }
  },
  mounted() {
    this.systemName = window.VUE_APP_System;
    if (this.systemName == "recommend") {
      //運動建議
      this.titleName = '運動項目推薦後台管理'
    } else {
      //運動行為
      this.titleName = '運動行為調查後台管理'
    }
    this.linecode = localStorage.getItem("linecode");
    if (this.isDev == '1') {
        this.linecode ='U2d06679ce81e3c95809062c2c48d517b'
      }
  },
  methods: {
    goUserListPage(){
      this.$router.push({ name: "UserListPage" });

    },
    cleanCatch() {
      localStorage.removeItem('userLoginType');
      localStorage.removeItem('linecode');
      localStorage.removeItem('idToken');
      localStorage.removeItem('googlecode');
      localStorage.removeItem('LIFF_STORE:2002453331-wK4xYK9O:loginTmp');
      localStorage.removeItem('LIFF_STORE:2002453323-20Lo31Kp:loginTmp');
      localStorage.removeItem('LIFF_STORE:2002453323-20Lo31Kp:context');
      localStorage.removeItem('LIFF_STORE:2002453331-wK4xYK9O:context');
      localStorage.removeItem('LIFF_STORE:2002453323-20Lo31Kp:decodedIDToken');
      localStorage.removeItem('LIFF_STORE:2002453323-20Lo31Kp:accessToken');
      localStorage.removeItem('LIFF_STORE:2002453331-wK4xYK9O:decodedIDToken');
      localStorage.removeItem('LIFF_STORE:2002453331-wK4xYK9O:accessToken');
      this.$router.push({ name: "HomePage" });

    },
  }
};
</script>

<style lang="css">
 .btn-DFD6C8{
    background-color: #DFD6C8 !important;
    color:#292524 !important;
    border-radius: 20px!important;
    font-weight: bold !important;
  }
  .btn-r20 {
  margin-right: 20px
}
/* 直接引入 CSS 文件 */
/* @import '@/assets/css/common.css';
@import '@/assets/css/themes/theme-minimal.css'; */
</style>

